// NPM Imports
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

// CSS imports
import styles from "./revvInput.module.scss";

// COMPONENTS Imports
import Label from "../Label";

class Input extends PureComponent {
  constructor(props) {
    super(props);
    this.inputId = `${Math.round(Math.random() * 10 ** 10)}`;
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.setFocus();
    }
  }

  get cloneClassName() {
    const { type, checked, disabled, className, isSwitch } = this.props;
    const isCheckedClass = checked ? styles.isChecked : "";
    const isDisabled = disabled ? styles.isDisabled : "";
    const additionalClasses = `${className} ${isCheckedClass} ${isDisabled}`;
    switch (type) {
      case "checkbox": {
        const checkBoxClassName = isSwitch ? styles.switch : styles.checkbox;
        return ` ${checkBoxClassName} ${additionalClasses}`;
      }
      case "radio":
        return `${styles.radio} ${additionalClasses}`;
      default:
        return "";
    }
  }

  get isCheckTypes() {
    const { type } = this.props;
    switch (type) {
      case "checkbox":
      case "radio":
        return true;
      default:
        return false;
    }
  }

  setFocus = () => {
    setTimeout(() => {
      if (this.inputRef && this.inputRef.current) {
        this.inputRef.current.focus();
      }
    }, 100);
  };

  render() {
    const { className, id, autoFocus, isFloat, isSwitch, type, ...otherProps } =
      this.props;

    if (!this.isCheckTypes) {
      return (
        <input
          data-test="input"
          id={id || this.inputId}
          className={`${styles.input} ${className}`}
          type={type}
          tabIndex="0"
          ref={this.inputRef}
          {...otherProps}
        />
      );
    }

    return (
      <Label
        className={`${styles.container} ${isSwitch ? styles.isSwitch : ""}`}
        htmlFor={id || this.inputId}>
        <span className={`${styles.hiddenWrapper}`}>
          <input
            data-test="input"
            id={id || this.inputId}
            type={type}
            tabIndex="0"
            ref={this.inputRef}
            {...otherProps}
          />
        </span>
        <i className={`${this.cloneClassName}`} />
      </Label>
    );
  }
}

Input.defaultProps = {
  autoFocus: false,
  checked: false,
  className: "",
  disabled: false,
  id: null,
  isFloat: false,
  isSwitch: false,
  name: "",
  onChange: null,
  placeholder: "",
  type: "text",
  value: "",
};

Input.propTypes = {
  autoFocus: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isFloat: PropTypes.bool,
  isSwitch: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Input;
